import React from 'react';
import PlayIcon from 'mdi-react/YoutubePlayIcon';
import { Thumbnail, PlayIconWrapper } from './styles';

export const VideoThumbnail: React.VFC<IVideoThumbnail> = props => (
  <Thumbnail className="pj-ui-carousel-video-thumbnail">
    <PlayIconWrapper className="pj-ui-carousel-video-thumbnail--play-icon">
      <PlayIcon />
    </PlayIconWrapper>
    <img src={props.src} alt="" />
  </Thumbnail>
);

interface IVideoThumbnail {
  src: string;
}
